import styled from 'styled-components';
import { ButtonGroup as ButtonGroupBT } from 'reactstrap';

export const ButtonGroup = styled(ButtonGroupBT)`
	@media (max-width: 400px) {
		display: flex !important;
		flex-direction: column;
	}
`;
